<ng-content></ng-content>

<ng-template #pointTpl>
	<div
		class="pos-abs unclickable"
		style="top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1"
	>
		<onboarding-spotlight-point></onboarding-spotlight-point>
	</div>

	<!-- <ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayPositions]="_pointPosition"
		[cdkConnectedOverlayOrigin]="elementRef"
		[cdkConnectedOverlayOpen]="true"
		[cdkConnectedOverlayScrollStrategy]="scrollStrategy"
	> -->
	<!-- <onboarding-spotlight-point></onboarding-spotlight-point> -->
	<!-- </ng-template> -->
</ng-template>

<ng-template #messageTpl let-message>
	<ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayPositions]="_messagePosition"
		[cdkConnectedOverlayOrigin]="elementRef"
		[cdkConnectedOverlayOpen]="true"
		[cdkConnectedOverlayFlexibleDimensions]="true"
		[cdkConnectedOverlayPush]="true"
		[cdkConnectedOverlayOffsetX]="_messageOffsetXMultiplier * 16"
		[cdkConnectedOverlayOffsetY]="_messageOffsetYMultiplier * 16"
		(positionChange)="_onMessagePositionChanged()"
	>
		<div class="m-1">
			<div class="pos-rel">
				<div #messageOverlay>
					<onboarding-spotlight-message
						[showFooter]="message.showFooter"
						[showGotIt]="message.showGotIt"
						(footerClicked)="showModal()"
						(markAsSeen)="_markAsSeen()"
					>
						<ng-container ngProjectAs="[title]">
							{{ message.data.title }}
						</ng-container>

						<ng-container ngProjectAs="[description]">
							<span [innerHTML]="message.data.description"></span>
						</ng-container>

						<ng-container ngProjectAs="[footer]">
							{{ message.data.footer }}
						</ng-container>
					</onboarding-spotlight-message>
				</div>

				<div
					class="pos-abs triangle unclickable"
					[style.left.px]="_messageLeftPx(messageOverlay)"
					[style.top.px]="_messageTopPx(messageOverlay)"
				></div>
			</div>
		</div>
	</ng-template>
</ng-template>

<ng-template #vcr></ng-template>
